import { render } from "./TemplateFrameImageOptionsSettings.vue?vue&type=template&id=1fa76f84&scoped=true"
import script from "./TemplateFrameImageOptionsSettings.vue?vue&type=script&lang=js"
export * from "./TemplateFrameImageOptionsSettings.vue?vue&type=script&lang=js"

import "./templateFrameOptionDisplays.scss?vue&type=style&index=0&id=1fa76f84&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fa76f84"]])

export default __exports__